import { PHONE_REGEX, LOOSE_EMAIL_REGEX } from '@shopee/validators';
import { isValidLocalMobilePhone } from '../phone';

export type AuthParamsFromAuthKey = {
  email?: string;
  phone?: string;
  username?: string;
};

export enum AuthKeyType {
  Email,
  Phone,
  Username,
}

/**
 * @deprecated please use V2 instead
 * @TODO Billy.tso migrate all places to v2
 * determine whether authKey = email / username / phone
 * output: an object with corresponding attribute and value depending on authKey type
 */
export function getAuthParamsFromAuthKey({
  authKey,
  isAllowEmail,
  isAllowPhone,
}: {
  authKey: string;
  isAllowEmail: boolean;
  isAllowPhone: boolean;
}): AuthParamsFromAuthKey {
  if (isAllowEmail && LOOSE_EMAIL_REGEX.test(authKey)) {
    return { email: authKey };
  }

  if (isAllowPhone && PHONE_REGEX.test(authKey)) {
    return { phone: authKey };
  }

  return { username: authKey };
}

/**
 * Determine whether authKey = email / username / phone
 * output: an object with corresponding attribute and value depending on authKey type
 * The main difference from V1 is that invalid local phone numbers will be treated as username
 */
export async function getAuthParamsFromAuthKeyV2({
  authKey,
  isAllowEmail,
  isAllowPhone,
}: {
  authKey: string;
  isAllowEmail: boolean;
  isAllowPhone: boolean;
}): Promise<AuthParamsFromAuthKey> {
  if (isAllowEmail && LOOSE_EMAIL_REGEX.test(authKey)) {
    return { email: authKey };
  }

  if (isAllowPhone && PHONE_REGEX.test(authKey)) {
    const authKeyIsPhone = await isValidLocalMobilePhone(authKey);
    if (authKeyIsPhone) {
      return { phone: authKey };
    }
  }

  return { username: authKey };
}

export function getAuthKeyType(params: AuthParamsFromAuthKey): AuthKeyType {
  if (params.email) return AuthKeyType.Email;
  if (params.phone) return AuthKeyType.Phone;
  return AuthKeyType.Username;
}
